import { Link, TextInput, Tile } from '@Components/common';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './BankDetailsForm.module.scss';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';
import { msgFieldRequired, VALIDATE_SORT_CODE_REGEX } from '@Helpers';
import { HelpCenterRoutes } from '@App/paths';

export const BankDetailsForm = () => {
  const { t } = useTranslation('account');
  const { register, errors } = useFormContext();

  return (
    <Tile
      title={{
        title: t('tabs.bank_details.add_bank_details'),
        subtitle: (
          <Trans
            ns="account"
            i18nKey="tabs.bank_details.add_bank_details_description"
            components={[
              <>
                <br />
                <br />
              </>,
              <Link href={HelpCenterRoutes.BANK_DETAILS} underline />,
            ]}
          />
        ),
      }}
      className={classNames(styles.bankDetailsTile)}
    >
      <div className={styles.bankDetailsContainer}>
        <TextInput
          label={t('tabs.bank_details.account_name')}
          name="account_name"
          type="text"
          inputRef={register({ required: msgFieldRequired })}
          error={!!errors.account_name}
          helperText={errors.account_name?.message}
          className={styles.shortField}
        />
        <TextInput
          label={t('tabs.bank_details.sort_code')}
          name="sort_code"
          type="text"
          inputRef={register({
            required: msgFieldRequired,
            pattern: {
              value: VALIDATE_SORT_CODE_REGEX,
              message: t('tabs.bank_details.invalid_sort_code'),
            },
          })}
          error={!!errors.sort_code}
          helperText={errors.sort_code?.message}
          className={styles.shortField}
        />
        <TextInput
          label={t('tabs.bank_details.account_number')}
          name="account_number"
          type="number"
          inputRef={register({ required: msgFieldRequired })}
          error={!!errors.account_number}
          helperText={errors.account_number?.message}
          className={styles.shortField}
        />
        <div>
          <img className={styles.img} src={'/assets/Stripe/powered_by_stripe_badge.svg'} alt="" />
          <p className={styles.stripeSubtext}>{t('tabs.bank_details.stripe_payment_text')}</p>
        </div>
      </div>
    </Tile>
  );
};
